'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { setCookieRedirectAfterAuth } from '@/features/auth/cookies/cookie-redirect-after-auth';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import Button from '@/ui/button/button';
import styles from './add-listing-button.module.scss';
export default function AddListingButton() {
  const $ = _c(6);
  const translationsListing = useTranslations("listing");
  const addListingAppFlyer = useAppFlyerLink("mobile", "mobileSearchAddListingButton", ROUTER_LINKS.phoneAuth);
  const handleNonLoggedClick = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cx(styles.addListing);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== translationsListing) {
    t1 = translationsListing("add-listing");
    $[1] = translationsListing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== addListingAppFlyer || $[4] !== t1) {
    t2 = <div className={t0}><Button href={addListingAppFlyer} onClick={handleNonLoggedClick} element="link" shade="dark" variant="filled" size="md" fontSize="s" fullWidth={true}>+{" "}{t1}</Button></div>;
    $[3] = addListingAppFlyer;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp() {
  setCookieRedirectAfterAuth(ROUTER_LINKS.listingsAdd);
}